import {
  columnFilteringFeature,
  columnVisibilityFeature,
  rowPaginationFeature,
  rowSortingFeature,
  tableFeatures,
} from '@tanstack/react-table';

export type SiteControlColumnMeta = {
  filterVariant?: 'text' | 'range' | 'select' | 'boolean' | 'date';
  options?: string[] | undefined;
  /** Overrides the table-wide `align` prop for this column's header only. */
  headerAlign?: 'left' | 'center' | 'right';
  /** Draws a vertical divider on the leading edge of this column's header cell. */
  headerDivider?: boolean;
};

/** Shared feature set for SiteControl tables (sorting, filtering, pagination). */
export const siteControlTableFeatures = tableFeatures({
  columnFilteringFeature,
  columnVisibilityFeature,
  rowSortingFeature,
  rowPaginationFeature,
  columnMeta: {} as SiteControlColumnMeta,
});

export type SiteControlTableFeatures = typeof siteControlTableFeatures;
